import { MockSearchProvider } from '../platforms/mock/MockSearchProvider';
import { UnbxdSearchProvider } from '../platforms/unbxd/UnbxdSearchProvider';
import { BoostSearchProvider } from '../platforms/boost/BoostSearchProvider';
import { AlgoliaSearchProvider } from '../platforms/algolia/AlgoliaSearchProvider';
import { ShopifySearchProvider } from '../platforms/shopify/ShopifySearchProvider';
import { SearchspringSearchProvider } from '../platforms/searchspring/SearchspringSearchProvider';
import AppConfig from '../config/config';
/** A simple lookup so the factory can stay clean & typed. */
export const providerMap = {
    unbxd: UnbxdSearchProvider,
    mock: MockSearchProvider,
    algolia: AlgoliaSearchProvider,
    boost: BoostSearchProvider,
    shopify: ShopifySearchProvider,
    searchspring: SearchspringSearchProvider,
};
export function getSearchProvider(providerType, mockPlatform) {
    const provider = providerType || AppConfig.provider;
    switch (provider) {
        case 'mock':
            const mockProvider = new MockSearchProvider();
            if (mockPlatform) {
                mockProvider.setMockPlatform(mockPlatform);
            }
            return mockProvider;
        case 'unbxd':
            return new UnbxdSearchProvider();
        case 'boost':
            return new BoostSearchProvider();
        case 'algolia':
            return new AlgoliaSearchProvider();
        case 'shopify':
            return new ShopifySearchProvider();
        case 'searchspring':
            return new SearchspringSearchProvider();
        default:
            throw new Error(`Unsupported provider: ${provider}`);
    }
}
